// Contains the codes for clinicaltrials.gov recruitment status
export enum RecruitmentStatus {
  notyetrecruiting = 'NOT_YET_RECRUITING',
  recruiting = 'RECRUITING',
  enrollingbyinvitation = 'ENROLLING_BY_INVITATION',
  activenotrecruiting = 'ACTIVE_NOT_RECRUITING',
  suspended = 'SUSPENDED',
  terminated = 'TERMINATED',
  completed = 'COMPLETED',
  withdrawn = 'WITHDRAWN',
  unknown = 'UNKNOWN',
}
